import RepeatedAppointment from './RepeatedAppointment'

export { RepeatedAppointment }

export default RepeatedAppointment
